/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Quote } from "./Quote";
import {
  QuoteFromJSON,
  QuoteFromJSONTyped,
  QuoteToJSON,
  QuoteToJSONTyped,
} from "./Quote";
import type { QuoteGroup } from "./QuoteGroup";
import {
  QuoteGroupFromJSON,
  QuoteGroupFromJSONTyped,
  QuoteGroupToJSON,
  QuoteGroupToJSONTyped,
} from "./QuoteGroup";
import type { SortedIndices } from "./SortedIndices";
import {
  SortedIndicesFromJSON,
  SortedIndicesFromJSONTyped,
  SortedIndicesToJSON,
  SortedIndicesToJSONTyped,
} from "./SortedIndices";

/**
 *
 * @export
 * @interface ShipmentQuotes
 */
export interface ShipmentQuotes {
  /**
   *
   * @type {string}
   * @memberof ShipmentQuotes
   */
  shipmentId: string;
  /**
   *
   * @type {QuoteGroup}
   * @memberof ShipmentQuotes
   */
  quoteGroup: QuoteGroup;
  /**
   *
   * @type {Array<Quote>}
   * @memberof ShipmentQuotes
   */
  quotesByPrice: Array<Quote>;
  /**
   *
   * @type {SortedIndices}
   * @memberof ShipmentQuotes
   */
  byCustomerPrice: SortedIndices;
  /**
   *
   * @type {SortedIndices}
   * @memberof ShipmentQuotes
   */
  byCarrierPrice: SortedIndices;
  /**
   *
   * @type {number}
   * @memberof ShipmentQuotes
   */
  quoteCount: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentQuotes
   */
  carrierCount: number;
  /**
   *
   * @type {boolean}
   * @memberof ShipmentQuotes
   */
  hasCustomerSpecificPricing: boolean;
}

/**
 * Check if a given object implements the ShipmentQuotes interface.
 */
export function instanceOfShipmentQuotes(
  value: object,
): value is ShipmentQuotes {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("quoteGroup" in value) || value["quoteGroup"] === undefined)
    return false;
  if (!("quotesByPrice" in value) || value["quotesByPrice"] === undefined)
    return false;
  if (!("byCustomerPrice" in value) || value["byCustomerPrice"] === undefined)
    return false;
  if (!("byCarrierPrice" in value) || value["byCarrierPrice"] === undefined)
    return false;
  if (!("quoteCount" in value) || value["quoteCount"] === undefined)
    return false;
  if (!("carrierCount" in value) || value["carrierCount"] === undefined)
    return false;
  if (
    !("hasCustomerSpecificPricing" in value) ||
    value["hasCustomerSpecificPricing"] === undefined
  )
    return false;
  return true;
}

export function ShipmentQuotesFromJSON(json: any): ShipmentQuotes {
  return ShipmentQuotesFromJSONTyped(json, false);
}

export function ShipmentQuotesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentQuotes {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    quoteGroup: QuoteGroupFromJSON(json["quoteGroup"]),
    quotesByPrice: (json["quotesByPrice"] as Array<any>).map(QuoteFromJSON),
    byCustomerPrice: SortedIndicesFromJSON(json["byCustomerPrice"]),
    byCarrierPrice: SortedIndicesFromJSON(json["byCarrierPrice"]),
    quoteCount: json["quoteCount"],
    carrierCount: json["carrierCount"],
    hasCustomerSpecificPricing: json["hasCustomerSpecificPricing"],
  };
}

export function ShipmentQuotesToJSON(json: any): ShipmentQuotes {
  return ShipmentQuotesToJSONTyped(json, false);
}

export function ShipmentQuotesToJSONTyped(
  value?: ShipmentQuotes | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    quoteGroup: QuoteGroupToJSON(value["quoteGroup"]),
    quotesByPrice: (value["quotesByPrice"] as Array<any>).map(QuoteToJSON),
    byCustomerPrice: SortedIndicesToJSON(value["byCustomerPrice"]),
    byCarrierPrice: SortedIndicesToJSON(value["byCarrierPrice"]),
    quoteCount: value["quoteCount"],
    carrierCount: value["carrierCount"],
    hasCustomerSpecificPricing: value["hasCustomerSpecificPricing"],
  };
}
